angular.module('zc.zenclerkS')

  .component('zcsExcludeIpEditor', {
    bindings: {
      project: '='
    },
    templateUrl: '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.html',
    controllerAs: 'vm',
    controller: function(ProjectExcludeIp, Ip, ZcsOemService) {
      const vm = this;
      // only this specific functionality
      vm.excludeIps = [];
      vm.currentIp = '';
      vm.ZcsOemService = '';

      this.$onInit = () => {
        Ip.get()
          .then(ip => {
            vm.currentIp = ip;
          });
        ProjectExcludeIp.all(vm.project.id)
          .then(excludeIps => {
            vm.excludeIps = excludeIps;
          });
        vm.ZcsOemService = ZcsOemService;
      };

      vm.addExcludeIp = () => {
        vm.excludeIps.push({
          project_id: vm.projectId,
          ip: ''
        });
      };

      vm.onDestroy = excludeIp => {
        if(!excludeIp) return;
        vm.excludeIps.splice(vm.excludeIps.indexOf(excludeIp), 1);
      };

    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.js